// Starter content is shared by the first-load editors and their paste placeholders.
// Saved account setups and browser drafts take precedence over these examples.

export const DEFAULT_RELIC_RUN_SOURCE_TEXT = [
    "The cat is sleeping on the sofa.",
    "Where did you put my keys?",
    "I don't need an umbrella today.",
    "First, wash your hands. Then, eat lunch.",
    "apple banana orange grape"
].join("\n");

export const DEFAULT_PICTIONARY_SOURCE_TEXT = [
    "apple; 사과; A red or green fruit.",
    "pencil; 연필; You use this to write or draw.",
    "house; 집; A building where people live.",
    "",
    "ice cream; 아이스크림; A cold, sweet dessert.",
    "school bus; 통학 버스; A vehicle that takes children to school.",
    "swimming pool; 수영장; A place where people swim.",
    "",
    "play soccer; 축구하다; After school, I like to ____.",
    "ride a bike; 자전거를 타다; I wear a helmet when I ____.",
    "brush my teeth; 양치하다; Before bed, I ____.",
    "",
    "bicycle; 자전거",
    "rainbow; 무지개",
    "butterfly; 나비",
    "",
    "cat",
    "dog",
    "tree",
    "",
    "cloud; ; A white ____ is floating in the sky.",
    "umbrella; ; I use an ____ when it rains.",
    "star; ; At night, I can see a bright ____ in the sky."
].join("\n");

export const DEFAULT_VAULT_SOURCE_TEXT = [
    "Everyday Words",
    "100 - Which animal says meow?; cat; 고양이",
    "200 - What do you use to tell the time?; clock; 시계",
    "300 - What do you wear on your feet?; shoes; 신발",
    "400 - What keeps you dry in the rain?; umbrella; 우산",
    "500 - Where can you borrow books?; library; 도서관",
    "",
    "English Basics",
    "100 - Choose am, is, or are: I ____ happy.; am; ~이다",
    "200 - Choose play or plays: She ____ soccer.; plays; (운동을) 하다",
    "300 - What is the past tense of go?; went; 갔다",
    "400 - What is the opposite of noisy?; quiet; 조용한",
    "500 - What is the plural of child?; children; 아이들",
    "",
    "Quick Maths",
    "100 - What is two plus three?; five; 다섯",
    "200 - What is ten minus four?; six; 여섯",
    "300 - What is three times four?; twelve; 열둘",
    "400 - How many sides does a triangle have?; three; 셋",
    "500 - What is half of fifty?; twenty-five; 스물다섯",
    "",
    "Science and Nature",
    "100 - Which part of a plant usually grows underground?; roots; 뿌리",
    "200 - What do bees make?; honey; 꿀",
    "300 - What is frozen water called?; ice; 얼음",
    "400 - Which planet do we live on?; Earth; 지구",
    "500 - What force pulls things toward the ground?; gravity; 중력",
    "",
    "Daily Life",
    "100 - What do you do when you are thirsty?; drink water",
    "200 - What do you do with a book?; read",
    "300 - You do this to keep your teeth clean.; brush your teeth",
    "400 - What is the opposite of turn left?; turn right",
    "500 - What should you say when someone helps you?; thank you"
].join("\n");

export const DEFAULT_PLANET_HOPPERS_PASTE_TEXT = [
    "1. Which animal has a trunk?",
    "a) Cat",
    "*b) Elephant",
    "c) Rabbit",
    "d) Horse",
    "Image: /planet-hoppers/samples/elephant.webp",
    "",
    "2. What is 3 + 4?",
    "a) 5",
    "b) 6",
    "*c) 7",
    "d) 8",
    "Image: /planet-hoppers/samples/counting.webp",
    "",
    "3. Choose the correct sentence.",
    "*a) She likes music.",
    "b) She like music.",
    "c) She liking music.",
    "d) She to like music.",
    "Image: /planet-hoppers/samples/music.webp",
    "",
    "4. What does 고맙습니다 mean?",
    "a) Hello",
    "b) Goodbye",
    "c) Good morning",
    "*d) Thank you",
    "Image: /planet-hoppers/samples/thank-you.webp"
].join("\n");

export const DEFAULT_PLANET_HOPPERS_SOURCE_TEXT = JSON.stringify({
    "version": 1,
    "title": "Planet Hoppers",
    "ordering": "ordered",
    "questions": [
        {
            "id": "starter-1",
            "prompt": "Which animal has a trunk?",
            "answers": [
                "Cat",
                "Elephant",
                "Rabbit",
                "Horse"
            ],
            "correct": 1,
            "image": {
                "kind": "image",
                "url": "/planet-hoppers/samples/elephant.webp",
                "credit": "Original Ziarcadia starter illustration",
                "fit": "contain"
            },
            "after": []
        },
        {
            "id": "starter-2",
            "prompt": "What is 3 + 4?",
            "answers": [
                "5",
                "6",
                "7",
                "8"
            ],
            "correct": 2,
            "image": {
                "kind": "image",
                "url": "/planet-hoppers/samples/counting.webp",
                "credit": "Original Ziarcadia starter illustration",
                "fit": "contain"
            },
            "after": []
        },
        {
            "id": "starter-3",
            "prompt": "Choose the correct sentence.",
            "answers": [
                "She likes music.",
                "She like music.",
                "She liking music.",
                "She to like music."
            ],
            "correct": 0,
            "image": {
                "kind": "image",
                "url": "/planet-hoppers/samples/music.webp",
                "credit": "Original Ziarcadia starter illustration",
                "fit": "contain"
            },
            "after": []
        },
        {
            "id": "starter-4",
            "prompt": "What does 고맙습니다 mean?",
            "answers": [
                "Hello",
                "Goodbye",
                "Good morning",
                "Thank you"
            ],
            "correct": 3,
            "image": {
                "kind": "image",
                "url": "/planet-hoppers/samples/thank-you.webp",
                "credit": "Original Ziarcadia starter illustration",
                "fit": "contain"
            },
            "after": []
        }
    ]
});
